import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { AddCircleOutline } from '@material-ui/icons';
import { Modal } from '@material-ui/core';
import { Wrap, Button, Highlight, ModalBox, Center } from './Footer.styled';
import ContentForFilters from './contentForFilters';
import { DESIGNATION_SHOULD_EXIST } from '../../Content/Components/Filters/Components/_shared/constants';
import { getLabelBasedOnOrgType } from '../../Content/Components/Filters/Components/_shared/utils';
import {
  fetchAudienceFilters,
  loadOrgTypeName,
} from '../../../../../../redux/action';

const nameMapper = {
  [DESIGNATION_SHOULD_EXIST]: 'Any/All Member Designations.',
};

const FilterStats = ({
  Icon,
  color,
  text,
  filters,
  backColor,
  audienceFilters,
  orgTypeName,
  orgId,
  orgTypeId,
  dispatch,
}) => {
  const [open, setOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState('');

  useEffect(() => {
    if (!audienceFilters.length && orgId) dispatch(fetchAudienceFilters(orgId));
    if (!orgTypeName && orgTypeId) dispatch(loadOrgTypeName(orgTypeId));
  }, [orgId, orgTypeId]);

  const handleOpen = name => {
    setActiveFilter(name);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getHighlightedData = () => {
    const listOfNames = Object.keys(filters);

    return listOfNames.map((name, index) => {
      const wordDelimiter = index !== listOfNames.length - 1 ? 'and' : '';
      const displayName =
        nameMapper[name] ??
        getLabelBasedOnOrgType(name, audienceFilters, orgTypeName);
      return (
        <b key={name}>
          <Button onClick={() => handleOpen(name)} backColor={backColor}>
            {displayName}{' '}
            <AddCircleOutline
              style={{ fontSize: 14, position: 'absolute', top: 2, right: 4 }}
            />
          </Button>
          {wordDelimiter}
        </b>
      );
    });
  };

  const activeFilterDisplayName = activeFilter
    ? nameMapper[activeFilter] ??
      getLabelBasedOnOrgType(activeFilter, audienceFilters, orgTypeName)
    : '';

  return (
    <Wrap>
      <Icon style={{ color: color, fontSize: 16, marginRight: 7 }} />
      {text}: {getHighlightedData()}
      <Modal open={open} onClose={handleClose} aria-labelledby={activeFilter}>
        <ModalBox style={{ overflow: 'scroll', maxHeight: '240px' }}>
          <Center>
            <Highlight padding="2px 10px" color="#5EAB00" backColor="#E6EAE2">
              {activeFilterDisplayName}
            </Highlight>
          </Center>
          <ContentForFilters filterName={activeFilter} />
        </ModalBox>
      </Modal>
    </Wrap>
  );
};

const mapStateToProps = state => ({
  audienceFilters: state.audience.audienceFilters,
  orgTypeName: state.audience.orgTypeName,
  orgId: state.organization.selected.id,
  orgTypeId: state.organization.selected.orgType,
});

export default connect(mapStateToProps)(FilterStats);
